import { RouteName } from '@/shared/enums';
import ViewType from './view-type';

export const insertTrackingPixel = ({ ipressoMonitoringPixel }) => {
  const oldPixel = document.getElementById('ipresso-pixel');

  if (oldPixel) {
    oldPixel.parentNode.removeChild(oldPixel);
  }

  const pixel = document.createElement('img');
  pixel.setAttribute('id', 'ipresso-pixel');
  pixel.style.display = 'none';
  pixel.src = ipressoMonitoringPixel;
  document.body.appendChild(pixel);
};

export const getViewParams = (router, categories) => {
  const { name, params, query } = router.currentRoute;

  let viewName = '';
  let viewType = '';

  switch (name) {
    case RouteName.HOME:
      viewType = ViewType.MAIN;
      viewName = 'MAIN';
      break;
    case RouteName.DETAIL:
    case RouteName.DETAIL_WITH_ARTICLE:
      viewType = ViewType.DETAIL;
      viewName = params.slug;
      break;
    case RouteName.CATALOG:
      viewType = ViewType.MAIN;
      viewName = (params.sublabel || params.label || '').toUpperCase();
      break;
    case RouteName.CATALOG_WITH_CATEGORY:
      const categoryId = parseInt(params.id, 10);
      const category = categories.get(categoryId);
      viewType = ViewType.CATEGORY;
      viewName = category.key;
      break;
    case RouteName.SUBSCRIBER_LOGIN:
      viewType = ViewType.MY_ACCOUNT;
      viewName = 'LOGIN';
      break;
    case RouteName.SUBSCRIBER_MY_ACCOUNT:
      viewType = ViewType.MY_ACCOUNT;
      viewName = 'MAIN';
      break;
    case RouteName.SEARCH:
      viewType = ViewType.SEARCH;
      viewName = query.query || '';
      break;
    case RouteName.SUBSCRIBER_REGISTER:
      viewType = ViewType.ONBOARDING;
      viewName = 'REGISTER';
      break;
    case RouteName.SUBSCRIBER_MAIL_VERIFY:
      viewType = ViewType.ONBOARDING;
      viewName = 'EMAIL_VERIFICATION';
      break;
    case RouteName.SUBSCRIBER_PASSWORD_RESET:
      viewType = ViewType.ONBOARDING;
      viewName = 'PASSWORD_SET';
      break;
    default:
      return;
  }

  return {
    param_view_name: viewName,
    param_view_type: viewType,
  };
};
